import { ServiceActionKeys, ServiceSlugs, ServiceType } from '@ply-io/ply-front-shared-utilities';

import {
	INTERFACE,
	// MAX_NUM_OF_APPS_TO_DISPLAY_IN_PREVIEW,
	// POPULAR_APPS_SLUGS,
	TABLE_MAPPER_MINI_APP,
	AI_MINI_APP,
	LOOM_MINI_APP,
	IMAGE_EDITOR_APP,
	CALENDLY_MINI_APP,
	GOOGLE_DOCS_MINI_APP,
	STRIPE_MINI_APP,
} from './BlockEditorAppSelect.const';

/* Private */

/* Public */

const compareFromListBySlug = (appsOptions, a, b) => {
	let aPosition = appsOptions.indexOf(a.service_slug);
	let bPosition = appsOptions.indexOf(b.service_slug);
	aPosition = aPosition === -1 ? aPosition * appsOptions.length * -1 : aPosition;
	bPosition = bPosition === -1 ? bPosition * appsOptions.length * -1 : bPosition;
	if (aPosition < bPosition) {
		return -1;
	} else if (aPosition > bPosition) {
		return 1;
	}
	return 0;
};
const sortByName = (a, b) => {
	const aName = a.service_name.toUpperCase();
	const bName = b.service_name.toUpperCase();
	return aName < bName ? -1 : aName > bName ? 1 : 0;
};
const sortByOrder = (a, b) => {
	if (a.order === b.order) {
		return 0;
	}
	if (!a.order && b.order) {
		return 1; // a is after b
	}
	if (!b.order && a.order) {
		return -1; // a is before b
	}
	return a.order - b.order;
};

function getMiniAppsMenuItems(widgetAppId, isAIMiniAppSupportOn, isLoomOn) {
	const miniApps = [
		{
			id: widgetAppId,
			service_slug: ServiceSlugs.Widgets,
			service_name: 'Table Mapper',
			type: INTERFACE,
			action_slug: ServiceActionKeys.RunMiniApp,
			miniAppType: TABLE_MAPPER_MINI_APP, // ugly patch for now...
			overrideIcon: 'csv-importer',
		},
	];
	if (isAIMiniAppSupportOn) {
		miniApps.push({
			id: widgetAppId,
			service_slug: ServiceSlugs.Widgets,
			service_name: 'AI Assistant',
			type: INTERFACE,
			action_slug: ServiceActionKeys.RunMiniApp,
			miniAppType: AI_MINI_APP, // ugly patch for now...
			overrideIcon: 'ai-input',
		});
	}
	if (isLoomOn) {
		miniApps.push({
			id: widgetAppId,
			service_slug: ServiceSlugs.Widgets,
			service_name: 'Loom recorder',
			type: INTERFACE,
			action_slug: ServiceActionKeys.RunMiniApp,
			miniAppType: LOOM_MINI_APP, // ugly patch for now x3...
			overrideIcon: 'loom',
		});
	}
	// if (this[isPinturaOn.fullPath]) {
	miniApps.push({
		id: widgetAppId,
		service_slug: ServiceSlugs.Widgets,
		service_name: 'Image editor',
		type: INTERFACE,
		action_slug: ServiceActionKeys.RunMiniApp,
		miniAppType: IMAGE_EDITOR_APP, // ugly patch for now x3...
		overrideIcon: 'image-editor',
	});
	miniApps.push({
		id: widgetAppId,
		service_slug: ServiceSlugs.Widgets,
		service_name: 'HubSpot scheduler',
		type: INTERFACE,
		action_slug: ServiceActionKeys.RunMiniApp,
		miniAppType: 'hubspot-scheduler', // ugly patch for now x3...
		overrideIcon: 'hubspot-scheduler',
	});
	miniApps.push({
		id: widgetAppId,
		service_slug: ServiceSlugs.Widgets,
		service_name: 'Calendly embed',
		type: INTERFACE,
		action_slug: ServiceActionKeys.RunMiniApp,
		miniAppType: CALENDLY_MINI_APP, // ugly patch for now x3...
		overrideIcon: 'calendly',
	});
	miniApps.push({
		id: widgetAppId,
		service_slug: ServiceSlugs.Widgets,
		service_name: 'Google Docs',
		type: INTERFACE,
		action_slug: ServiceActionKeys.RunMiniApp,
		miniAppType: GOOGLE_DOCS_MINI_APP, // ugly patch for now x3...
		overrideIcon: 'google-docs',
	});

	miniApps.push({
		id: widgetAppId,
		service_slug: ServiceSlugs.Widgets,
		service_name: 'Stripe embedded checkout',
		type: INTERFACE,
		action_slug: ServiceActionKeys.RunMiniApp,
		miniAppType: STRIPE_MINI_APP, // ugly patch for now x3...
		overrideIcon: 'stripe',
	});

	return miniApps;
}

function getAppsItems(apps, selectedWorkflowElement, widgetAppId) {
	const getAppsByType = (type) => apps.filter((e) => e.type === type);
	const getInterfaceApps = () => {
		const realApps = getAppsByType(INTERFACE);
		const miniAppsFatherItem = {
			type: INTERFACE,
			id: widgetAppId, //this.widgetApp?.id,
			isMiniApp: true,
			service_name: 'Mini-apps',
			service_slug: 'mini-apps',
			description: 'A user-facing step with built-in functionality',
		};

		return [...realApps, miniAppsFatherItem];
	};
	const getContextApps = () => {
		const { service: elementService, version: elementServiceVersion } = selectedWorkflowElement || {}; // selectedWorkflowElement can be null
		return apps.filter((app) => app.type === ServiceType.Context && app.id === elementService && app.version === elementServiceVersion);
	};
	return {
		all: [...apps],
		[ServiceType.Context]: {
			apps: getContextApps(),
			displayText: 'Context specific action',
		},
		[INTERFACE]: {
			apps: getInterfaceApps(),
			displayText: 'Interfaces',
		},
		[ServiceType.Ply]: {
			apps: getAppsByType(ServiceType.Ply),
			displayText: 'Helpers',
		},
		[ServiceType.Integration]: {
			apps: getAppsByType(ServiceType.Integration),
			displayText: 'Integrations',
		},
		[ServiceType.Internal]: {
			apps: getAppsByType(ServiceType.Internal),
			displayText: 'Internal apps - you see this only because you are allowed to',
		},
	};
}

function isMiniApp(widgetFieldType) {
	return [TABLE_MAPPER_MINI_APP, AI_MINI_APP, LOOM_MINI_APP, IMAGE_EDITOR_APP].includes(widgetFieldType);
}

const BlockEditorAppSelectService = {
	compareFromListBySlug,
	sortByName,
	sortByOrder,
	getMiniAppsMenuItems,
	getAppsItems,
	isMiniApp,
};

export default BlockEditorAppSelectService;
